<template>
  <div class="coupon">
    <component :is="componentType" title="Do you have a Coupon Code?">
      <tml-item-tray wide-left-item align-items-center>
        <template #primary>
          <div class="basket-coupon-input">
            <tml-form form-name="coupon-form">
              <tml-input
                v-model="internalCoupon"
                field-name="coupon-input"
                :background-color="theme().get(themeColor)"
                placeholder="Gift card or discount code"
                :show-action-button="noAccordion"
                @on-action="applyCoupon"
                @on-submit="applyCoupon"
              />
            </tml-form>
          </div>
        </template>
        <template v-if="!noAccordion" #secondary>
          <tml-button
            fill
            text="Apply"
            :loading="loading"
            @click="applyCoupon"
          />
        </template>
      </tml-item-tray>
      <p v-if="internalMessage" class="py-2 center">
        {{ internalMessage }}
      </p>
    </component>
  </div>
</template>

<script>
export default {
  name: 'CartCouponForm',

  inject: ['theme'],

  props: {
    code: String,
    context: {
      type: String,
      default: 'cart',
    },
    message: String,
    noAccordion: Boolean,
    themeColor: {
      type: String,
      default: 'box.background.color',
    },
  },

  data() {
    return {
      loading: false,
      internalCoupon: '',
      internalMessage: '',
    };
  },

  computed: {
    componentType() {
      return this.noAccordion ? 'div' : 'tml-expandable-container';
    },
  },

  watch: {
    code: {
      immediate: true,
      handler(code) {
        const nextCode = code ?? '';

        if (nextCode !== this.internalCoupon) {
          this.internalCoupon = nextCode;
        }
      },
    },
    message: {
      immediate: true,
      handler(message) {
        const nextMessage = message ?? '';

        if (nextMessage !== this.internalMessage) {
          this.internalMessage = nextMessage;
        }
      },
    },
  },

  methods: {
    applyCoupon() {
      if (this.loading === true) {
        return;
      }

      this.loading = true;

      new Promise((resolve, reject) => {
        this.$emit(
          'apply-coupon',
          this.internalCoupon,
          resolve,
          reject,
          this.context
        );
      })
        .then(message => {
          this.internalMessage = message;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.coupon {
  .basket-coupon-input {
    .wrapper {
      margin: 0;
    }
  }
}
</style>
